export default function (props: any) {
    return (
        <svg
            width="54px"
            height="54px"
            viewBox="0 0 54 54"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            {...props}
        >
            <defs>
                <linearGradient x1="21.875%" y1="0%" x2="78.125%" y2="100%" id="linearGradient-1">
                    <stop stopColor="#07E307" offset="0%"></stop>
                    <stop stopColor="#28CFD6" offset="100%"></stop>
                </linearGradient>
            </defs>
            <g id="页面-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="River-2-详情页" transform="translate(-1179.000000, -4180.000000)">
                    <g id="时间备份-3" transform="translate(1179.000000, 4180.000000)">
                        <rect id="矩形" fillRule="nonzero" x="0" y="0" width="54" height="54"></rect>
                        <path
                            d="M19.25,2 L33.875,2 C34.8069805,2 35.5625,2.75551948 35.5625,3.6875 C35.5625,4.61948052 34.8069805,5.375 33.875,5.375 L19.25,5.375 C18.3180195,5.375 17.5625,4.61948052 17.5625,3.6875 C17.5625,2.75551948 18.3180195,2 19.25,2 Z M19.25,48.125 L33.875,48.125 C34.8069805,48.125 35.5625,48.8805195 35.5625,49.8125 C35.5625,50.7444805 34.8069805,51.5 33.875,51.5 L19.25,51.5 C18.3180195,51.5 17.5625,50.7444805 17.5625,49.8125 C17.5625,48.8805195 18.3180195,48.125 19.25,48.125 Z M26.5625,8.1875 C36.8142857,8.1875 45.125,16.4982143 45.125,26.75 C45.125,37.0017857 36.8142857,45.3125 26.5625,45.3125 C16.3107143,45.3125 8,37.0017857 8,26.75 C8,16.4982143 16.3107143,8.1875 26.5625,8.1875 Z M26.5625,11.5625 C18.1746754,11.5625 11.375,18.3621754 11.375,26.75 C11.375,35.1378246 18.1746754,41.9375 26.5625,41.9375 C34.9503246,41.9375 41.75,35.1378246 41.75,26.75 C41.75,18.3621754 34.9503246,11.5625 26.5625,11.5625 Z M25.4771764,18.3125 C26.4091569,18.3125 27.1646764,19.0680195 27.1646764,20 L27.164,26.187 L31.1021764,26.1875 C32.0341569,26.1875 32.7896764,26.9430195 32.7896764,27.875 C32.7896764,28.8069805 32.0341569,29.5625 31.1021764,29.5625 L25.4771764,29.5625 C24.5451959,29.5625 23.7896764,28.8069805 23.7896764,27.875 L23.7896764,20 C23.7896764,19.0680195 24.5451959,18.3125 25.4771764,18.3125 Z"
                            id="形状结合"
                            fill="url(#linearGradient-1)"
                        ></path>
                    </g>
                </g>
            </g>
        </svg>
    );
}
